import React, { PropsWithRef } from "react";
import styled, { CSSProp } from "styled-components";

const ObjectTag = styled.object<{ aspectRatio: number }>`
  ${(props) => `aspect-ratio: ${props.aspectRatio};`}

  &.full-width {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
  }
`;

interface SvgObjectProps {
  data: string;
  width: number;
  height: number;
  title?: string;
  css?: CSSProp;
  className?: string;
}

const SvgObject: React.FunctionComponent<PropsWithRef<SvgObjectProps>> = ({
  data,
  width,
  height,
  ...props
}) => (
  <ObjectTag
    type="image/svg+xml"
    data={data}
    aspectRatio={width / height}
    {...props}
  />
);

export default SvgObject;
